/*global angular*/
(function () {
    'use strict';

    angular.module('resortApp').constant('regions', window.VCAppData.regions || {});

}());
